import React from 'react';
import { FieldAutomationIds } from '../../../../global/constants/field-automation-ids';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface InstitutionListLabelsProps {
	settings: SearchProps,
}

export const InstitutionListLabels = (props: InstitutionListLabelsProps) => {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell' data-testid={FieldAutomationIds.clientNumberCellLabel}>
				<SortButton label={props.settings?.institutionIdLabel} name='client_number' />
			</div>
			<div className='sort-table-row-cell' data-testid={FieldAutomationIds.institutionNameLabel}>
				<SortButton label={props.settings?.institutionNameLabel} name='legal_name' />
			</div>

			<div className='sort-table-row-cell' data-testid={FieldAutomationIds.institutionCityLabel}>
				<SortButton label={props.settings?.institutionCityLabel} name='city' />
			</div>			
		</div>
	);

};